import { FieldModel } from '@cibo/core'
import { FertilizerCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface FertilizerCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const FertilizerCell = ({ value, task, year, selectedField }: FertilizerCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="fertilizer"
    >
      <FertilizerCellDisplay value={value} />
    </TraitCellContainer>
  )
}
